import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
// layouts
import HomeLayout from '../layouts/home';

// ----------------------------------------------------------------------

const HomeRoutes = {
  path: '*',
  layout: HomeLayout,
  routes: [
    {
      path: '/',
      component: lazy(() => import('../views/LandingPage'))
    },
    {
      component: () => <Navigate to="/404" />
    }
  ]
};

export default HomeRoutes;
